import styled from 'styled-components';

export const Title = styled.p`
  color: #222;
  font-family: Poppins;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 28px; /* 127.273% */
  letter-spacing: var(--Headline-Small-Tracking, 0px);
`;
